<template>
  <div class="otpWrapper">
    <p id="code" v-html="code" :class="codeStatus" />
    <canvas id="pieTimer" width="20" height="20" />
  </div>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      passedSec: 0,
      timer: "",
    };
  },
  mounted() {
    this.currentOtpTimestamp = this.otpTimestamp;
    this.nowTimer();
    this.timer = setInterval(this.nowTimer, 1000);
  },
  unmounted() {
    clearTimeout(this.timer);
  },
  computed: {
    codeStatus() {
      // if (this.passedSec == 0 || this.passedSec == 30) {
      //   return "hide";
      // }
      if (this.passedSec > 24 && this.passedSec < 30) {
        return "warnning";
      }
      return "";
    },
  },
  methods: {
    piePainter() {
      const canvas = document.getElementById("pieTimer");
      if (canvas == null) {
        return;
      }
      const ctx = canvas.getContext("2d");
      const halfSize = canvas.width / 2;
      const deg =
        this.passedSec == 0 || this.passedSec == 30 ? 0.1 : this.passedSec * 12;
      const start = (270 * Math.PI) / 180;
      const end = ((deg + 270) * Math.PI) / 180;
      ctx.clearRect(0, 0, 20, 20);
      ctx.fillStyle =
        this.passedSec > 24 && this.passedSec < 30 ? "#F5645E" : "#33CEAA";
      ctx.beginPath();
      ctx.moveTo(halfSize, halfSize);
      ctx.arc(halfSize, halfSize, halfSize, start, end, true);
      ctx.lineTo(halfSize, halfSize);
      ctx.fill();
    },
    nowTimer() {
      this.passedSec = Math.floor(Date.now() / 1000) % 30;
      this.piePainter();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.otpWrapper
  +size(100%, auto)
  +flex()
  #code
    +ffw(bold, num)
    +fs(xxxl)
    text-align: center
    color: $color1
    letter-spacing: 0.3em
    margin-bottom: 16px
    opacity: 1
    &.warnning
      color: $color3
    &.hide
      color: $gs1
  #pieTimer
    +size(20px)
    background-color: $gs1
    border-radius: 10px
</style>
